import { apiSlice } from "../api/apiSlice";

export const taskAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (id) => `/tasks/${id}`,
    }),
    addTask: builder.mutation({
      query: (data) => ({
        url: "/tasks",
        method: "POST",
        body: data,
      }),

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(addResult.data);
            })
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
    ediTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const editResult = await queryFulfilled;

          //Update Tasks Cache
          await dispatch(
            apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
              let target = draft.findIndex(
                (task) => Number(task.id) === arg.id
              );
              draft[target] = editResult.data;
            })
          );

          //Update Task Cache for edit
          const id = String(arg.id);
          await dispatch(
            apiSlice.util.updateQueryData("getTask", id, (draft) => {
              draft.taskName = editResult.data.taskName;
              draft.teamMember = editResult.data.teamMember;
              draft.project = editResult.data.project;
              draft.deadline = editResult.data.deadline;
              draft.status = editResult.data.status;
            })
          );
        } catch (error) {
          console.error("Something went Wrong!");
        }
      },
    }),
    changeTaskStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted({ id, data }, { queryFulfilled, dispatch }) {
        const deleteResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            let target = draft.find((task) => Number(task.id) === id);
            console.log(target);
            target.status = data.status;
          })
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Changed Task Status!");
          }
        } catch (error) {
          deleteResult.undo();
          console.log(error);
        }
      },
    }),
    deleteTask: builder.mutation({
      query: (id) => ({
        url: `tasks/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const deleteResult = dispatch(
          apiSlice.util.updateQueryData("getTasks", undefined, (draft) => {
            const targetIndex = draft.findIndex(
              (task) => Number(task.id) === arg
            );
            draft.splice(targetIndex, 1);
          })
        );

        try {
          const result = await queryFulfilled;
          if (result.meta.response.status === 200) {
            console.log("Successfully Deleted!");
          }
        } catch (error) {
          deleteResult.undo();
          console.log(error);
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useAddTaskMutation,
  useEdiTaskMutation,
  useDeleteTaskMutation,
  useChangeTaskStatusMutation,
} = taskAPI;
